import { FC } from "react";

import { SidebarIcon } from "@/assets/icons";

type Props = {
  isSidebarOpen: boolean;
  onToggle: () => void;
};

/**
 * Sole owner of the chat-history toggle. It rides with the chat column rather
 * than a page-level header so collapsing the sidebar never moves it, and so it
 * can be handed to the SDK chat component untouched once that ships a header
 * slot — today `LokasiAIContent` takes no children.
 */
const SidebarToggle: FC<Props> = ({ isSidebarOpen, onToggle }) => (
  <button
    type="button"
    onClick={onToggle}
    aria-label={isSidebarOpen ? "Hide chat history" : "Show chat history"}
    className="flex shrink-0 items-center rounded-md p-1 hover:bg-teal-50 [&>svg]:h-5 [&>svg]:w-5 [&>svg]:fill-dim-gray"
  >
    <SidebarIcon />
  </button>
);

export default SidebarToggle;
